import {
    ApiBaseService,
    type ApiServiceConfig,
} from "~/services/ApiBaseService";
import type { ApiResponse } from "~/types/ApiResponse";

export interface GoogleSheet {
    id: string | number;
    name: string;
}

export default class FacebookService extends ApiBaseService {
    protected uuid: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config);

        this.uuid = uuid;
    }

    public processAuth(params): Promise {
        return this.request(
            this.route(
                "api.connections.google.auth",
                "/connections/google/auth"
            ),
            {
                method: "POST",
                query: params
            }
        );
    }

    public getSheets(): Promise<ApiResponse<GoogleSheet[]>> {
        return this.request(
            this.route(
                "api.connections.google.sheets.index",
                "/connections/google/{connection}/sheets",
                {
                    connection: this.uuid,
                }
            ),
            {
                method: "GET",
            }
        );
    }

    public getWorkSheets(sheetId: string | number): Promise<ApiResponse<GoogleSheet[]>> {
        return this.request(
            this.route(
                "api.connections.google.sheets.worksheets",
                "/connections/google/{connection}/sheets/{sheetId}/worksheets",
                {
                    connection: this.uuid,
                    sheetId: sheetId
                }
            ),
            {
                method: "GET",
            }
        );
    }

    public getColumns(sheetId: string | number, worksheetId: string | number): Promise<ApiResponse<GoogleSheet[]>> {
        return this.request(
            this.route(
                "api.connections.google.sheets.columns",
                "/connections/google/{connection}/sheets/{sheetId}/{worksheetId}/columns",
                {
                    connection: this.uuid,
                    sheetId: sheetId,
                    worksheetId: worksheetId
                }
            ),
            {
                method: "GET",
            }
        );
    }

}
